<template>
  <div id="authority-modal-parent">
    <Page title="権限管理">
      <template v-slot:content>
        <AuthorityTable :headers="headers" :datas="tableDatas" @open-form="openForm" />
      </template>
    </Page>
    <div class="uk-flex-top employee-form-modal" uk-modal ref="modal" container="#authority-modal-parent" :bg-close="false">
      <AuthorityForm
        ref="authForm"
        :mode="mode"
        :headers="modalHeaders"
        :selectedPermissionId="selectedPermissionId"
        @confirm="onConfirm"
        @delete="onDelete"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@include table-action;
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import Page from "../molecules/Page.vue";
import AuthorityTable from "../organisms/AuthorityTable.vue";
import Store from "../../store";
import { AuthApi, OperationRangesEnum } from "../../autogen";
import AuthorityForm from "../organisms/AuthorityForm.vue";
import UIkit from "uikit";

interface Header {
  text: string;
  colspan?: string;
  rowspan?: string;
  style?: Object;
  containModal: boolean;
  required?: boolean;
  helpIconMessage?: string;
}

interface StrKeyObject {
  [key: string]: any;
}
interface RowData {
  id: string;
  name: string;
  operationRange: keyof typeof OperationRangesEnum;
  permissions: StrKeyObject;
}
interface FormValue {
  name: string;
  permissions: StrKeyObject;
}

@Options({
  components: {
    Page,
    AuthorityTable,
    AuthorityForm
  }
})
export default class Authority extends Vue {
  private readonly storeInstance = Store.getInstance();
  @Ref("modal") modal!: HTMLElement;
  mode: "add" | "edit" = "add";
  tableDatas: Object[] = [];
  headers: Header[][] = [
    [
      {
        text: "",
        colspan: "1",
        rowspan: "1",
        style: { borderLeft: "hidden", borderTop: "hidden" },
        containModal: true,
        required: false
      },
      {
        text: "",
        colspan: "1",
        rowspan: "1",
        style: { borderLeft: "hidden", borderTop: "hidden" },
        containModal: true,
        required: false
      },
      {
        text: "",
        colspan: "1",
        rowspan: "1",
        style: { borderLeft: "hidden", borderTop: "hidden", minWidth: "100px" },
        containModal: false,
        required: false
      },
      {
        text: "従業員",
        colspan: "3",
        rowspan: "1",
        style: {
          background: "#5cafff",
          color: "#fff",
          fontSize: "16px",
          borderRadius: "8px 8px 0 0",
          borderLeft: "hidden",
          borderTop: "hidden",
          borderRight: "hidden"
        },
        containModal: true,
        required: false
      },
      {
        text: "応募者",
        colspan: "3",
        rowspan: "1",
        style: {
          background: "#fc974a",
          color: "#fff",
          fontSize: "16px",
          borderRadius: "8px 8px 0 0",
          borderLeft: "hidden",
          borderTop: "hidden",
          borderRight: "hidden"
        },
        containModal: true,
        required: false,
        helpIconMessage: "応募者に部署が設定されていない場合、閲覧範囲が全ての従業員のみに表示されます"
      },
      {
        text: "分析",
        colspan: "1",
        rowspan: "1",
        style: {
          background: "#7abeff",
          color: "#fff",
          fontSize: "16px",
          borderRadius: "8px 8px 0 0",
          borderLeft: "hidden",
          borderTop: "hidden",
          borderRight: "hidden"
        },
        containModal: true,
        required: false
      },
      {
        text: "アセスメントサーベイ",
        colspan: "3",
        rowspan: "1",
        style: {
          background: "#eace66",
          color: "#fff",
          fontSize: "16px",
          borderRadius: "8px 8px 0 0",
          borderLeft: "hidden",
          borderTop: "hidden",
          borderRight: "hidden"
        },
        containModal: true,
        required: false
      },
      {
        text: "管理",
        colspan: "3",
        rowspan: "1",
        style: {
          background: "#91db51",
          color: "#fff",
          fontSize: "16px",
          borderRadius: "8px 8px 0 0",
          borderLeft: "hidden",
          borderTop: "hidden",
          borderRight: "hidden"
        },
        containModal: true,
        required: false
      },
      {
        text: "特別管理",
        colspan: "4",
        rowspan: "1",
        style: {
          background: "#ff9aba",
          color: "#fff",
          fontSize: "16px",
          borderRadius: "8px 8px 0 0",
          borderLeft: "hidden",
          borderTop: "hidden",
          borderRight: "hidden"
        },
        containModal: true,
        required: false
      }
    ],
    [
      {
        text: "権限名",
        colspan: "1",
        rowspan: "2",
        style: { color: "#555", fontSize: "16px" },
        containModal: true,
        required: true
      },
      {
        text: "範囲",
        colspan: "1",
        rowspan: "2",
        style: { color: "#555", fontSize: "16px" },
        containModal: true,
        required: true
      },
      { text: "", colspan: "1", rowspan: "2", style: { color: "#555", fontSize: "16px" }, containModal: false, required: false },
      {
        text: "従業員管理",
        colspan: "2",
        rowspan: "1",
        style: { background: "#b8dcff", color: "#555", fontSize: "16px" },
        containModal: true,
        required: false
      },
      {
        text: "受検結果",
        colspan: "1",
        rowspan: "1",
        style: { background: "#b8dcff", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      },
      {
        text: "応募者管理",
        colspan: "2",
        rowspan: "1",
        style: { background: "#ffdbbd", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      },
      {
        text: "受検結果",
        colspan: "1",
        rowspan: "1",
        style: {
          background: "#ffdbbd",
          color: "#555",
          fontSize: "14px"
        },
        containModal: true,
        required: false
      },
      {
        text: "参照",
        colspan: "1",
        rowspan: "2",
        style: {
          background: "#b8dcff",
          color: "#555",
          fontSize: "14px"
        },
        containModal: true,
        required: false
      },
      {
        text: "参照•作成•更新",
        colspan: "3",
        rowspan: "2",
        style: { background: "#f9f1d2", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      },
      {
        text: "参照•作成•更新•削除",
        colspan: "3",
        rowspan: "2",
        style: { background: "#e4f6d5", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      },
      {
        text: "参照•作成•更新•削除",
        colspan: "3",
        rowspan: "2",
        style: { background: "#ffe8ef", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      }
    ],
    [
      {
        text: "参照",
        colspan: "1",
        rowspan: "1",
        style: { background: "#b8dcff", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      },
      {
        text: "作成•更新•削除",
        colspan: "1",
        rowspan: "1",
        style: { background: "#b8dcff", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      },
      {
        text: "参照",
        colspan: "1",
        rowspan: "1",
        style: { background: "#b8dcff", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      },
      {
        text: "参照",
        colspan: "1",
        rowspan: "1",
        style: { background: "#ffdbbd", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      },
      {
        text: "作成•更新•削除",
        colspan: "1",
        rowspan: "1",
        style: { background: "#ffdbbd", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      },
      {
        text: "参照",
        colspan: "1",
        rowspan: "1",
        style: { background: "#ffdbbd", color: "#555", fontSize: "14px" },
        containModal: true,
        required: false
      }
    ]
  ];
  selectedPermissionId = "";

  get modalHeaders() {
    return this.headers.map(row => {
      return row.filter(col => col.containModal);
    });
  }

  private async fetchRoles() {
    const response = await new AuthApi().getRoles({});
    this.tableDatas = response.data;
  }

  mounted() {
    this.fetchRoles();
  }

  onConfirm() {
    this.fetchRoles();
    UIkit.modal(this.modal).hide();
  }

  async onDelete() {
    this.fetchRoles();
    UIkit.modal(this.modal).hide();
  }
  private openForm(mode: "add" | "edit", rowData: RowData) {
    (this.$refs.authForm as AuthorityForm).clearForm();
    if (mode === "edit") {
      this.selectedPermissionId = rowData.id;
      // @ts-ignore
      (this.$refs.authForm as AuthorityForm).setFormValue({
        name: rowData.name,
        operationRange: rowData.operationRange,
        permissions: rowData.permissions
      });
    } else if (mode === "add") {
      // @ts-ignore
      (this.$refs.authForm as AuthorityForm).setFormValue({
        name: "",
        operationRange: "none",
        permissions: {
          employee: ["read"],
          applicant: [],
          analysis: [],
          manage: [],
          specialManage: [],
          asBroadcast: [],
          employeeStats: [],
          applicantStats: []
        }
      });
    }
    this.mode = mode;
    UIkit.modal(this.modal).show();
  }
}
</script>
